export default __webpack_public_path__ + "static/media/backArrow.00cd2915.svg";